import React, { useMemo, useState } from "react";
import { Col, Row } from "reactstrap";
import Card from "components/Card";
import Text from "components/Text";
import moment from "moment/moment";
import { convertTimeMinuteToHour, encodeId } from "utils";
import { withTranslation } from "react-i18next";
import styles from "./../Offices.module.scss";
import constants from "../../../../constants";
import { addEditEventsConst } from "../../../../accountOwner/pages/AddEvent/addEvents.constants";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const RequestApprovalcard = ({ t, list, officeId, handleAction }) => {
  const history = useHistory();
  const { leaveStatus, timesheetListingStatus } = useMemo(
    () => ({
      leaveStatus: constants.LeaveStatus,
      timesheetListingStatus: constants.TimesheetListingStatus,
    }),
    []
  );
  const [commentForLeaveState, setCommentForLeaveState] = useState("");
  const startTime = moment(list?.timesheet_StartTime, "h:mm A");
  const endTime = moment(list?.timesheet_EndTime, "h:mm A");
  let duration = moment.duration(moment(endTime).diff(moment(startTime)));

  // Subtract the break duration from the total duration
  const totalDurationWithoutBreak = duration.subtract(
    list?.timesheet_BreakTime,
    "minutes"
  );
  let totalHours = totalDurationWithoutBreak.asHours().toFixed(2);

  const appliedForDate = (startDate, endDate) => {
    let appliedDate = `${moment(startDate).format("MMM D")} - ${moment(
      endDate
    ).format("ll")}`;
    return appliedDate;
  };

  const handlePendingRequestAction = (
    actionType,
    actionTypeId,
    statusId,
    isApproved
  ) => {
    handleAction(
      actionType,
      actionTypeId,
      statusId,
      isApproved,
      commentForLeaveState
    );
  };

  const handleLeaveStatus = (statusId) => (
    <>
      {statusId === leaveStatus[1].value && <span>{t("pending")}</span>}
      {statusId === leaveStatus[2].value && (
        <span>{t("staffTimesheet.approved")}</span>
      )}
      {statusId === leaveStatus[3].value && <span>{t("rejected")}</span>}
    </>
  );
  let isShift = list?.eventShiftTag === "Shift" ? true : false;
  const isCancelled = list?.leave_Status === leaveStatus[6].value;
  const leaveClass = isCancelled ? styles["cancelationleave"] : styles["leave"];
  const leaveTextKey = isCancelled
    ? "staffLeaves.leaveCancellation"
    : "staffTimesheet.leave";
  return (
    <Card
      className={styles["request-approval-card"]}
      radius="10px"
      padding="30px"
      marginBottom="10px"
      shadow="0 0 15px 0 rgba(0, 0, 0, 0.08)"
      cursor="default"
      background-color="#F9FCEE"
    >
      <div className="d-flex justify-content-between">
        <div className={styles["request-div"]}>
          <Text size="16px" marginBottom="15px" weight="600" color="#587E85">
            {list?.timesheetId > 0 && <span> {list?.timesheet_Name}</span>}
            {list?.leave_Id > 0 && <span> {list?.leave_Name}</span>}
            {list?.clockInOutTimeSheetEditRequestId > 0 && (
              <span> {list?.editRequest_Name}</span>
            )}
            {list?.eventShiftId > 0 && (
              <span> {list?.eventShiftAssignedBy}</span>
            )}
          </Text>
        </div>
        <div>
          {list?.leave_Id > 0 && (
            <span className={`${styles["approval-status"]} ${leaveClass}`}>
              {t(leaveTextKey)}
            </span>
          )}
          {list?.isHoliday && (
            <span
              className={
                styles["approval-status"] + " me-xxs " + styles["holiday"]
              }
            >
              {" "}
              {t("staff.holiday")}
            </span>
          )}
          {list?.timesheetId > 0 && (
            <span className={styles["approval-status"]}>
              {t("contracts.timesheet")}
            </span>
          )}
          {list?.clockInOutTimeSheetEditRequestId > 0 && (
            <span className={styles["approval-status"]}>
              {t("staffTimesheet.editTimesheet")}
            </span>
          )}
          {list?.eventShiftId > 0 && (
            <span
              className={styles["approval-status"] + " " + styles["shiftevent"]}
            >
              {" "}
              {isShift ? "Shift" : "Event"}
            </span>
          )}
        </div>
      </div>
      <div className={styles["content-box"]}>
        <Row>
          {/* For Pendig timesheets */}
          {list?.timesheetId > 0 && (
            <>
              <Col sm="4" xs="6">
                <Text
                  size="12px"
                  marginBottom="5px"
                  weight="400"
                  color="#6f7788"
                >
                  {t("staffTimesheet.date")}
                </Text>
                <Text
                  size="14px"
                  marginBottom="25px"
                  weight="600"
                  color="#102c42"
                >
                  {list.timesheet_Date
                    ? moment(list.timesheet_Date).format("ll")
                    : "--"}
                </Text>
              </Col>
              <Col sm="4" xs="6">
                <Text
                  size="12px"
                  marginBottom="5px"
                  weight="400"
                  color="#6f7788"
                >
                  {t("staffTimesheet.started")}
                </Text>
                <Text
                  size="14px"
                  marginBottom="25px"
                  weight="600"
                  color="#102c42"
                >
                  {list.timesheet_StartTime ? list.timesheet_StartTime : "--"}
                </Text>
              </Col>
              <Col sm="4" xs="6">
                <Text
                  size="12px"
                  marginBottom="5px"
                  weight="400"
                  color="#6f7788"
                >
                  {t("staffTimesheet.finished")}
                </Text>
                <Text
                  size="14px"
                  marginBottom="25px"
                  weight="600"
                  color="#102c42"
                >
                  {list.timesheet_EndTime ? list.timesheet_EndTime : "--"}
                </Text>
              </Col>
              <Col sm="4" xs="6">
                <Text
                  size="12px"
                  marginBottom="5px"
                  weight="400"
                  color="#6f7788"
                >
                  {t("staffTimesheet.break")}
                </Text>
                <Text
                  size="14px"
                  marginBottom="25px"
                  weight="600"
                  color="#102c42"
                >
                  {list.timesheet_BreakTime
                    ? `${convertTimeMinuteToHour(list.timesheet_BreakTime)} Hrs`
                    : "--"}
                </Text>
              </Col>
              <Col sm="4" xs="6">
                <Text
                  size="12px"
                  marginBottom="5px"
                  weight="400"
                  color="#6f7788"
                >
                  {t("staffTimesheet.total")}
                </Text>
                <Text
                  size="14px"
                  marginBottom="25px"
                  weight="600"
                  color="#102c42"
                >
                  {totalHours ? `${totalHours} Hrs` : "--"}
                </Text>
              </Col>
            </>
          )}
          {list?.eventShiftId > 0 && (
            <>
              <Col sm="4" xs="6">
                <Text
                  size="12px"
                  marginBottom="5px"
                  weight="400"
                  color="#6f7788"
                >
                  {t("staffTimesheet.date")}
                </Text>
                <Text
                  size="14px"
                  marginBottom="25px"
                  weight="600"
                  color="#102c42"
                >
                  {list.eventShiftDate
                    ? moment(list?.eventShiftDate).format("ll")
                    : "--"}
                </Text>
              </Col>
              {[2, 3, 5, 6].includes(list?.repeatedType) && (
                <Col sm="4" xs="6">
                  <Text
                    size="12px"
                    marginBottom="5px"
                    weight="400"
                    color="#6f7788"
                  >
                    end date
                  </Text>
                  <Text
                    size="14px"
                    marginBottom="25px"
                    weight="600"
                    color="#102c42"
                  >
                    {list.eventShiftEndDateRepeatEvent
                      ? moment(list?.eventShiftEndDateRepeatEvent).format("ll")
                      : "--"}
                  </Text>
                </Col>
              )}
              <Col sm="4" xs="6">
                <Text
                  size="12px"
                  marginBottom="5px"
                  weight="400"
                  color="#6f7788"
                >
                  Repeat
                </Text>
                <Text
                  size="14px"
                  marginBottom="25px"
                  weight="600"
                  color="#102c42"
                >
                  {
                    addEditEventsConst
                      .repeatedOptions(t)
                      .find((res) => list?.repeatedType === res.id)?.name
                  }
                </Text>
              </Col>
              <Col sm="4" xs="6">
                <Text
                  size="12px"
                  marginBottom="5px"
                  weight="400"
                  color="#6f7788"
                >
                  {t("staffTimesheet.started")}
                </Text>
                <Text
                  size="14px"
                  marginBottom="25px"
                  weight="600"
                  color="#102c42"
                >
                  {list?.eventShiftStartTime
                    ? moment(list?.eventShiftStartTime).format("hh:mm A")
                    : "--"}
                </Text>
              </Col>
              <Col sm="4" xs="6">
                <Text
                  size="12px"
                  marginBottom="5px"
                  weight="400"
                  color="#6f7788"
                >
                  {t("staffTimesheet.finished")}
                </Text>
                <Text
                  size="14px"
                  marginBottom="25px"
                  weight="600"
                  color="#102c42"
                >
                  {list?.eventShiftEndTime
                    ? moment(list?.eventShiftEndTime).format("hh:mm A")
                    : "--"}
                </Text>
              </Col>
            </>
          )}
          {list?.leave_Id > 0 && (
            <>
              <Col sm="4" xs="6">
                <Text
                  size="12px"
                  marginBottom="5px"
                  weight="400"
                  color="#6f7788"
                >
                  {t("staffTimesheet.appliedFor")}
                </Text>
                <Text
                  size="14px"
                  marginBottom="25px"
                  weight="600"
                  color="#102c42"
                >
                  {appliedForDate(list.leave_FromDate, list.leave_ToDate)}
                </Text>
              </Col>
              <Col sm="4" xs="6">
                <Text
                  size="12px"
                  marginBottom="5px"
                  weight="400"
                  color="#6f7788"
                >
                  {t("staffTimesheet.duration")}
                </Text>
                <Text
                  size="14px"
                  marginBottom="25px"
                  weight="600"
                  color="#102c42"
                >
                  {list?.leave_Duration ? `${list.leave_Duration} Days` : "--"}
                </Text>
              </Col>
              <Col sm="4" xs="6">
                <Text
                  size="12px"
                  marginBottom="5px"
                  weight="400"
                  color="#6f7788"
                >
                  {t("staffTimesheet.typeOfLeave")}
                </Text>
                <Text
                  size="14px"
                  marginBottom="25px"
                  weight="600"
                  color="#102c42"
                >
                  {list.leave_Type}
                </Text>
              </Col>
              <Col sm="4" xs="6">
                <Text
                  size="12px"
                  marginBottom="5px"
                  weight="400"
                  color="#6f7788"
                >
                  {t("staffTimesheet.status")}
                </Text>
                <Text
                  size="14px"
                  marginBottom="25px"
                  weight="600"
                  color="#102c42"
                >
                  {list?.leave_Status
                    ? handleLeaveStatus(list?.leave_Status)
                    : "--"}
                </Text>
              </Col>
              <Col sm="12" xs="6">
                <Text
                  size="12px"
                  marginBottom="5px"
                  weight="400"
                  color="#6f7788"
                >
                  {t("staffLeaves.reasonForLeave")}
                </Text>
                <Text
                  size="14px"
                  marginBottom="25px"
                  weight="600"
                  color="#102c42"
                >
                  {list?.leave_Description ? list?.leave_Description : "--"}
                </Text>
              </Col>
              <Col sm="12" xs="6" className="c-field">
                <Text
                  size="12px"
                  marginBottom="5px"
                  weight="400"
                  color="#6f7788"
                >
                  {t("taskManagement.addComment")}
                </Text>
                <textarea
                  className="c-form-control bg-transparent"
                  placeholder={t("taskManagement.addComment")}
                  name="location"
                  maxLength={500}
                  value={commentForLeaveState}
                  onChange={(e) => {
                    setCommentForLeaveState(e.target.value);
                  }}
                ></textarea>
              </Col>
            </>
          )}
          {list?.clockInOutTimeSheetEditRequestId > 0 && (
            <>
              <Col sm="4" xs="6">
                <Text
                  size="12px"
                  marginBottom="5px"
                  weight="400"
                  color="#6f7788"
                >
                  {t("staffTimesheet.date")}
                </Text>
                <Text
                  size="14px"
                  marginBottom="25px"
                  weight="600"
                  color="#102c42"
                >
                  {list.timesheetRequest_Date
                    ? moment(list.timesheetRequest_Date).format("ll")
                    : "--"}
                </Text>
              </Col>
              <Col sm="4" xs="6">
                <Text
                  size="12px"
                  marginBottom="5px"
                  weight="400"
                  color="#6f7788"
                >
                  {t("staffTimesheet.started")}
                </Text>
                <Text
                  size="14px"
                  marginBottom="25px"
                  weight="600"
                  color="#102c42"
                >
                  {list.timesheet_StartTime ? list.timesheet_StartTime : "--"}
                </Text>
              </Col>
              <Col sm="4" xs="6">
                <Text
                  size="12px"
                  marginBottom="5px"
                  weight="400"
                  color="#6f7788"
                >
                  {t("staffTimesheet.finished")}
                </Text>
                <Text
                  size="14px"
                  marginBottom="25px"
                  weight="600"
                  color="#102c42"
                >
                  {list.timesheet_EndTime ? list.timesheet_EndTime : "--"}
                </Text>
              </Col>
              <Col sm="4" xs="6">
                <Text
                  size="12px"
                  marginBottom="5px"
                  weight="400"
                  color="#6f7788"
                >
                  {t("staffTimesheet.break")}
                </Text>
                <Text
                  size="14px"
                  marginBottom="25px"
                  weight="600"
                  color="#102c42"
                >
                  {list.timesheet_BreakTime
                    ? `${convertTimeMinuteToHour(list.timesheet_BreakTime)} Hrs`
                    : "--"}
                </Text>
              </Col>
              <Col sm="4" xs="6">
                <Text
                  size="12px"
                  marginBottom="5px"
                  weight="400"
                  color="#6f7788"
                >
                  {t("staffTimesheet.total")}
                </Text>
                <Text
                  size="14px"
                  marginBottom="25px"
                  weight="600"
                  color="#102c42"
                >
                  {list.timesheet_EndTime &&
                  list.timesheet_StartTime &&
                  totalHours
                    ? `${totalHours} Hrs`
                    : "--"}
                </Text>
              </Col>
              <Col sm="12" xs="6">
                <Text
                  size="12px"
                  marginBottom="5px"
                  weight="400"
                  color="#6f7788"
                >
                  {t("staffTimesheet.reasonForEditTimesheet")}
                </Text>
                <Text
                  size="14px"
                  marginBottom="25px"
                  weight="600"
                  color="#102c42"
                >
                  {list?.reason ? list?.reason : "--"}
                </Text>
              </Col>
            </>
          )}
        </Row>
        <button
          className="button button-round button-shadow mr-md-4 w-sm-100 mb-3 mb-md-0"
          onClick={() => {
            if (list?.timesheetId > 0) {
              handlePendingRequestAction(
                "Timesheet",
                list.timesheetId,
                timesheetListingStatus[2].value
              ); //actionType, actionTypeId, statusId, isApproved
            }
            if (list?.leave_Id > 0) {
              handlePendingRequestAction("Leave", list.leave_Id, null, true); //actionType, actionTypeId, statusId, isApproved
            }
            if (list?.clockInOutTimeSheetEditRequestId > 0) {
              handlePendingRequestAction(
                "EditTimesheetRequest",
                list.clockInOutTimeSheetEditRequestId,
                null,
                true
              ); //actionType, actionTypeId, statusId, isApproved
            }
            if (list?.eventShiftId > 0) {
              handlePendingRequestAction(
                "shiftEvent",
                list.eventShiftId,
                null,
                true
              );
            }
          }}
          title={t("accept")}
        >
          {t("accept")}
        </button>

        {list?.leave_Status !== 1 && list?.timesheet_Date && (
          <button
            className="button button-round button-shadow mr-md-4 w-sm-100 mb-3 mb-md-0"
            title={t("edit")}
            onClick={() => {
              list["timesheetDate"] = list?.timesheet_Date;
              history.push({
                pathname: constants.routes.accountOwner.editTimesheetForStaff
                  .replace(":officeId", encodeId(officeId))
                  .replace(":staffId", encodeId(list?.userId)),
                state: {
                  detail: list,
                  staffDetail: {
                    name:
                      list?.timesheetId > 0
                        ? list?.timesheet_Name
                        : list?.editRequest_Name,
                  },
                },
              });
            }}
          >
            {t("edit")}
          </button>
        )}

        <button
          className={
            "button button-round button-border btn-mobile-link button-dark"
          }
          onClick={() => {
            if (list?.timesheetId > 0) {
              handlePendingRequestAction(
                "Timesheet",
                list.timesheetId,
                timesheetListingStatus[3].value
              );
            }
            if (list?.leave_Id > 0) {
              handlePendingRequestAction("Leave", list.leave_Id, null, false);
            }
            if (list?.clockInOutTimeSheetEditRequestId > 0) {
              handlePendingRequestAction(
                "EditTimesheetRequest",
                list.clockInOutTimeSheetEditRequestId,
                null,
                false
              );
            }
            if (list?.eventShiftId > 0) {
              handlePendingRequestAction(
                "shiftEvent",
                list.eventShiftId,
                null,
                false
              );
            }
          }}
          title={t("decline")}
        >
          {t("decline")}
        </button>
      </div>
    </Card>
  );
};

export default withTranslation()(RequestApprovalcard);
